<template>
  <div
    class="reg-input van-hairline--bottom"
    :class="[
      focus || currentValue ? 'focus' : ''
    ]"
  >
    <div class="title font30">
      {{ placeholder }}
    </div>

    <van-field
      v-model="currentValue"
      ref="regInput"
      :type="type"
      class="text-space"
      @change="$emit('update:value', currentValue)"
      @focus="focusEvent()"
      @blur="blurEvent()"
      required
    >
      <slot
        name="button"
        slot="button"
      />
    </van-field>
  </div>
</template>

<script>
import { Field } from 'vant'

export default {
  name: 'RegInput',
  components: {
    [Field.name]:Field,
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isType: {
      type: [Function, Object],
      default: () => true
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  data() {
    return {
      currentValue: '',
      focus: false
    }
  },
  created () {
    this.currentValue =
      this.value === undefined || this.value === null ? '' : this.value
  },
  methods: {
    valid() {
      return this.$refs.regInput.valid
    },
    focusEvent() {
      this.focus = true
    },
    blurEvent() {
      this.focus = false
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    },
    currentValue (val) {
      this.$emit('on-change', val)
    }
  }
}
</script>

<style lang="less" scoped>
.van-cell {
  position: initial;
}

.reg-input {
  width: 100%;
  margin-top: 10px;

  .title {
    color: @color-text-gray;
    font-size: @font-size-14;
    transition: 0.3s all;
    transform: translate(21px, 35px);
  }
}

.reg-input.focus {
  .title {
    font-size: @font-size-16;
    transform: translate(0, 0);
  }
}

</style>


